export enum DATA_QA {
  ROOT = 'phone-change-log-item',
  AUTHOR_NAME = 'phone-change-log-item-author-name',
  DATE = 'phone-change-log-item-date',
  MESSAGE = 'phone-change-log-item-message',
  CHANGES = 'phone-change-log-item-changes',
  FIELD = 'phone-change-log-item-field',
  FIELD_NAME = 'phone-change-log-item-field-name',
  FIELD_OLD_VALUE = 'phone-change-log-item-field-old-value',
  FIELD_NEW_VALUE = 'phone-change-log-item-field-new-value',
  CSV_NAME = 'phone-change-log-item-csv-name',
}
